import { render, staticRenderFns } from "./KeywordResearch.vue?vue&type=template&id=67c32eda&"
import script from "./KeywordResearch.vue?vue&type=script&lang=js&"
export * from "./KeywordResearch.vue?vue&type=script&lang=js&"
import style0 from "./KeywordResearch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports